import { FormControlLabel, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

interface IconTextLinkProps {
  link?: string;
  icon?: React.ReactElement;
  text: string;
  onClick?: React.MouseEventHandler;
  isPrimary?: boolean;
  opacity?: boolean;
  isBody2?: boolean;
  disabled?: boolean;
}

const IconTextLink = ({
  disabled,
  link,
  icon,
  text,
  onClick,
  isPrimary,
  opacity,
  isBody2 = false,
}: IconTextLinkProps) => (
  <Link component={RouterLink} width={'100%'} underline="none" to={disabled ? '#' : link ?? ''}>
    <FormControlLabel
      disabled={disabled}
      control={icon ?? <></>}
      label={
        <Box pl={1}>
          <WsTypography
            variant={isBody2 ? WsTypoVariants.BODY2 : WsTypoVariants.BODY1}
            color={isPrimary ? WsTypoColors.PRIMARY : WsTypoColors.BLACK}
            onClick={onClick}
            cursor="pointer"
            opacity={opacity}
          >
            {text}
          </WsTypography>
        </Box>
      }
    />
  </Link>
);
export default IconTextLink;
